export const Table2MultirowTestPageObject = (
    instances: readonly string[],
    onAddInstance: () => void,
    handleRemoveInstance: (instance: string) => void
) => ({
    getType: () => "Table2Multirow",

    getInstancesCount: () => instances.length,

    addInstance: () => onAddInstance(),

    deleteInstance: (instance: string) => handleRemoveInstance(instance),
});
